module.exports = __webpack_public_path__ + "static/media/Journey 02 01.a43a92df.png";